export const APP_VERSION = "1.4.0";
export const APP_DEVELOPER = "SRM International Real Estate LLC";
